<template>
  <BaseChecklist
    v-bind="$attrs"
    v-model="modelValue"
    :loading="isFetching"
    :options="options"
    label="Brokers"
    :search-keys="['text']"
    searchable
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { useCurrentUser, useRLSGroup, useUserCompanyRLS } from '@composables'
import { BaseChecklist } from '@components/base'

export default defineComponent({
  name: 'BDXWizardBrokers',
  components: {
    BaseChecklist
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  emits: ['init', 'input'],
  setup(props, { emit }) {
    const { isSuperUser } = useCurrentUser()

    const { isFetching, rlsGroupItems } = useRLSGroup('Broker')
    const { brokerIds } = useUserCompanyRLS()

    const options = computed(() =>
      rlsGroupItems.value
        .filter((rlsGroupItem) => {
          if (isSuperUser.value) return true

          return brokerIds.value.includes(rlsGroupItem.id)
        })
        .map((rlsGroupItem) => ({
          value: rlsGroupItem.id,
          text: rlsGroupItem.broker
        }))
    )

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      isFetching,

      options,
      modelValue
    }
  }
})
</script>
